export const DefaultLoginPageURL = "/login"
export const DefaultIndexPageURL = "/"
export const DefaultWelcomePageURL = "/welcome"

export const QueryContinuePage = "continue"
export const DefaultAvatarUrl = "/images/no_avatar.jpg"
export const DefaultImageUrl = "/images/no_image.png"
export const LogoUrl = "/images/logo.svg"

export const DefaultAvatar = "https://f.malond.kz/images/anonymous.png"
